module.exports = __webpack_public_path__ + "MI6dgjSRC-R9mVouC/agent-training-center_navigating_common_challenges.png";